<!-- File: IoT-User-Frontend/src/views/AuthTest.vue -->

<template>
    <div>

        <!-- Breadcrumb Area -->

        <Breadcrumb mainTitle="Auth Test" breadContent="Placeholder" subTitle="Auth Test" />

        <!-- Auth Test Section  -->

        <div class="section-padding">
            <p>User is signed in: {{ isSignedIn }}</p>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

import Breadcrumb from '@/components/Breadcrumb.vue'
import Session from 'supertokens-web-js/recipe/session';

export default {
    name: 'AuthTest',
    components: { Breadcrumb },
    data() {
        return {
            isSignedIn: null
        }
    },
    methods: {
        async doesSessionExist() {
            if (await Session.doesSessionExist()) {
                return true;
            } else {
                return false;
            }
        }
    },
    async mounted() {
        this.isSignedIn = await this.doesSessionExist();
    }
}
</script>